module.exports = __webpack_public_path__ + "img/calendar-23_fill.125982b8.svg";